import axios from "axios";
import { toast } from "react-toastify";
// import { calculateTimeLeft } from "./Timer";
import { API_URL } from "utils/ApiUrl";

export const fetchBatchData = async (userNfts, setLoading) => {
  if (!userNfts || userNfts.length === 0) return;

  const filteredNfts = userNfts.filter((nft) => nft?.isMoreThan30Days);

  const tokenIds = filteredNfts.map((nft) => nft?.nftId);
  // const nextClaimedPeriods = filteredNfts.map((nft) => nft?.nextClaimedAt);
  // const amounts = filteredNfts.map((userNft) => {
  //   const amount1 = userNft?.rentPerNft;
  //   const amount2 = parseFloat(amount1.toFixed(6));
  //   return web3.utils.toWei(amount2.toString(), "mwei");
  // });

  try {
    setLoading(true);
    const accessToken = window.localStorage.getItem("accessToken");

    const response = await axios.post(
      `${API_URL}/claims/generate-multiple-claim`,
      { tokenIds },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response?.data?.data || [];
    return {
      tokenIds,
      amounts: data.amounts,
      nextClaimPeriods: data.nextClaimedAts,
      deadline: data.deadline,
      signature: data.signedKey,
    };
  } catch (error) {
    if (error?.response) {
      console.error("Batch claim data error:", error.response.data.message);
      toast.error(error.response.data.message);
    } else {
      console.error("Error generating batch claim data:", error.message);
      toast.error("Failed to generate batch claim data. Please try again.");
    }
  } finally {
    setLoading(false);
  }
};
